"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

var _common = require("../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _filterHelper = require("../../utils/filter-helper");

var _filterHelper2 = _interopRequireDefault(_filterHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterService = function FilterService(EventsService, NavigationService) {
  "ngInject";

  var filterType = _filterHelper2.default.filterType;

  var _usersFilterOptions = _filterHelper2.default.usersFilterOptions;

  var _profilesFilterOptions = _filterHelper2.default.profilesFilterOptions;

  var _mediaFilterOptions = _filterHelper2.default.mediaFilterOptions;

  var _surveyFilterOptions = _filterHelper2.default.surveyFilterOptions;

  var _certificatesFilterOptions = _filterHelper2.default.certificatesFilterOptions;

  var _checksFilterOptions = _filterHelper2.default.checksFilterOptions;

  var _jobsFilterOptions = _filterHelper2.default.jobsFilterOptions;

  var _jobRequestsFilterOptions = _filterHelper2.default.jobRequestsFilterOptions;

  var _affiliatesFilterOptions = _filterHelper2.default.affiliatesFilterOptions;

  var _vouchesFilterOptions = _filterHelper2.default.vouchesFilterOptions;

  var _botManagerFilterOptions = _filterHelper2.default.botManagerFilterOptions;

  var _botSessionsFilterOptions = _filterHelper2.default.botSessionsFilterOptions;

  var _businessesFilterOptions = _filterHelper2.default.businessesFilterOptions;

  var _globalUsersFilterOptions = _filterHelper2.default.globalUsersFilterOptions;

  var _globalJobsFilterOptions = _filterHelper2.default.globalJobsFilterOptions;

  var _globalJobsRequestsFilterOptions = _filterHelper2.default.globalJobRequestsFilterOptions;

  var _globalCertificatesFilterOptions = _filterHelper2.default.globalCertificatesFilterOptions;

  var _globalCheckssFilterOptions = _filterHelper2.default.globalChecksFilterOptions;

  var _globalAffiliatesFilterOptions = _filterHelper2.default.globalAffiliatesFilterOptions;

  var _globalBotManagerFilterOptions = _filterHelper2.default.globalBotManagerFilterOptions;

  var _globalVouchesFilterOptions = _filterHelper2.default.globalVouchesFilterOptions;

  var _globalBotSessionsFilterOptions = _filterHelper2.default.globalBotSessionsFilterOptions;

  var _globalBusinessesFilterOptions = _filterHelper2.default.globalBusinessesFilterOptions;

  var _filterExpression = {};

  var generateFilterExpression = function generateFilterExpression(filters) {
    _filterExpression = {
      logic: 'and',
      filters: []
    };

    for (var i = 0; i < filters.length; i++) {

      var filterItem = filters[i];

      if (filterItem.isActive && (filterItem.value || filterItem.field === "gender" && filterItem.value === 0)) {
        var filter = void 0;

        if (filterItem.filterType == filterType.FREE_TEXT) {
          var value = filterItem.value;
          if (filterItem.field == "userId" || filterItem.field == "userNumberOfJobPosts") value = parseInt(value);

          filter = {
            field: filterItem.field,
            operator: filterItem.filterIitems[filterItem.filterItemSelected].operator,
            value: value
          };
        } else if (filterItem.filterType == filterType.DROP_DOWN) {
          filter = {
            field: filterItem.field,
            operator: "eq",
            value: filterItem.value
          };
        } else if (filterItem.filterType == filterType.DATE_PICKER) {
          filter = {
            field: filterItem.field,
            operator: filterItem.filterIitems[filterItem.filterItemSelected].operator,
            value: _common2.default.converToUtcDate(filterItem.value)
          };
        }

        _filterExpression.filters.push(filter);
      }
    }

    console.log("_filterExpression", _filterExpression);
  };

  var getAppliedFilters = function getAppliedFilters() {
    return _filterExpression;
  };

  // Get global filter options

  var getGlobalUsersFilterOptions = function getGlobalUsersFilterOptions() {
    return _globalUsersFilterOptions;
  };

  var getGlobalJobsFilterOptions = function getGlobalJobsFilterOptions() {
    return _globalJobsFilterOptions;
  };

  var getGlobalJobRequestsFilterOptions = function getGlobalJobRequestsFilterOptions() {
    return _globalJobsRequestsFilterOptions;
  };

  var getGlobalAffiliatesFilterOptions = function getGlobalAffiliatesFilterOptions() {
    return _globalAffiliatesFilterOptions;
  };

  var getGlobalVocuhesFilterOptions = function getGlobalVocuhesFilterOptions() {
    return _globalVouchesFilterOptions;
  };

  var getGlobalCertificatesFilterOptions = function getGlobalCertificatesFilterOptions() {
    return _globalCertificatesFilterOptions;
  };

  var getGlobalCheckssFilterOptions = function getGlobalCheckssFilterOptions() {
    return _globalCheckssFilterOptions;
  };

  var getGlobalBotManagerFilterOptions = function getGlobalBotManagerFilterOptions() {
    return _globalBotManagerFilterOptions;
  };

  var getGlobalBotSessionsFilterOptions = function getGlobalBotSessionsFilterOptions() {
    return _globalBotSessionsFilterOptions;
  };

  var getGlobalBusinessesFilterOptions = function getGlobalBusinessesFilterOptions() {
    return _globalBusinessesFilterOptions;
  };

  ////////////


  var getUsersFilterOptions = function getUsersFilterOptions(globaFilterType) {

    switch (globaFilterType) {
      case _constants2.default.globalUsersFilterTypes.PAYG_USERS:
        return _applyPAYGModifier(_usersFilterOptions);
      case _constants2.default.globalUsersFilterTypes.ALL_PAYING_USERS:
        return _applyPayingSinceModifier(_usersFilterOptions);
      case _constants2.default.globalUsersFilterTypes.NSW_CUSTOMERS:
        return _applyNSWModifier(_usersFilterOptions);
      case _constants2.default.globalUsersFilterTypes.VIC_CUSTOMERS:
        return _applyVICModifier(_usersFilterOptions);
      case _constants2.default.globalUsersFilterTypes.ALL_USERS:
        return _resetFilterOptions(_usersFilterOptions);
      default:
        return _usersFilterOptions;
    }
  };

  var getBusinessesFilterOptions = function getBusinessesFilterOptions(globalFilterType) {
    switch (globalFilterType) {
      case _constants2.default.globalBusinessesFilterTypes.NSW_BUSINESSES:
        return _applyNSWBusinessModifier(_businessesFilterOptions);
      case _constants2.default.globalBusinessesFilterTypes.VIC_BUSINESSES:
        return _applyVICBusinessModifier(_businessesFilterOptions);
      default:
        return _businessesFilterOptions;
    }
  };

  var getProfilesFilterOptions = function getProfilesFilterOptions(globaFilterType) {

    switch (globaFilterType) {
      default:
        return _profilesFilterOptions;
    }
  };

  var getMediaFilterOptions = function getMediaFilterOptions() {
    return _mediaFilterOptions;
  };

  var getSurveyFilterOptions = function getSurveyFilterOptions() {
    return _surveyFilterOptions;
  };

  var getCertificatesFilterOptions = function getCertificatesFilterOptions(globalFilterType) {
    switch (globalFilterType) {
      case _constants2.default.globalCertificatesFilterTypes.PENDING_VERIFICATION:
        return _applyPendingVerificationCertificatesModifier(_certificatesFilterOptions);
      case _constants2.default.globalCertificatesFilterTypes.ALL_CERTIFICATES:
        return _resetFilterOptions(_certificatesFilterOptions);
      default:
        return _certificatesFilterOptions;
    }
  };

  var getChecksFilterOptions = function getChecksFilterOptions(globalFilterType) {
    switch (globalFilterType) {
      case _constants2.default.globalChecksFilterTypes.ALL_CHECKS:
        return _resetFilterOptions(_checksFilterOptions);
      default:
        return _checksFilterOptions;
    }
  };

  var getJobsFilterOptions = function getJobsFilterOptions(globaFilterType) {
    switch (globaFilterType) {
      case _constants2.default.globalJobsFilterTypes.ALL_JOBS:
        return _resetFilterOptions(_jobsFilterOptions);
      case _constants2.default.globalJobsFilterTypes.JOBS_POSTED_TODAY:
        return _applyJobsPostedTodayModifier(_jobsFilterOptions);
      case _constants2.default.globalJobsFilterTypes.JOBS_EXPIRE_TODAY:
        return _applyJobsExpireTodayModifier(_jobsFilterOptions);
      case _constants2.default.globalJobsFilterTypes.RECURRING_JOB_POSTED_15_DAYS_AGO:
        return _applyRecurringJobsPosted15DaysAgoModifier(_jobsFilterOptions);
      default:
        return _jobsFilterOptions;
    }
  };

  var getJobRequestsFilterOptions = function getJobRequestsFilterOptions(globaFilterType) {
    switch (globaFilterType) {
      case _constants2.default.globalJobRequestsFilterTypes.ALL_JOB_REQUESTS:
        return _resetFilterOptions(_jobRequestsFilterOptions);
      default:
        return _jobRequestsFilterOptions;
    }
  };

  var _applyEmployeeBenefitsModifier = function _applyEmployeeBenefitsModifier(filterOptions) {
    var modifiedFilter = filterOptions.map(function (option) {
      var optionModified = void 0;
      if (option.field == "affiliateSource") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 2 });
      } else {
        optionModified = (0, _assign2.default)({}, option, { isActive: false });
      }

      return optionModified;
    });
    console.log("Modified Filter", modifiedFilter);
    return modifiedFilter;
  };

  var _applyReferralModifier = function _applyReferralModifier(filterOptions) {
    var modifiedFilter = filterOptions.map(function (option) {
      var optionModified = void 0;
      if (option.field == "affiliateSource") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 1 });
      } else if (option.field == "affiliateStatus") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 2 });
      } else {
        optionModified = (0, _assign2.default)({}, option, { isActive: false });
      }

      return optionModified;
    });
    console.log("Modified Filter", modifiedFilter);
    return modifiedFilter;
  };

  var getAffiliatesFilterOptions = function getAffiliatesFilterOptions(globaFilterType) {
    switch (globaFilterType) {
      case _constants2.default.globalAffiliatesFilterTypes.ALL_AFFILIATES:
        return _resetFilterOptions(_affiliatesFilterOptions);
      case _constants2.default.globalAffiliatesFilterTypes.EMPLOYEE_BENEFITS:
        return _applyEmployeeBenefitsModifier(_affiliatesFilterOptions);
      case _constants2.default.globalAffiliatesFilterTypes.REFERRALS:
        return _applyReferralModifier(_affiliatesFilterOptions);
      default:
        return _affiliatesFilterOptions;
    }
  };

  var getVouchesFilterOptions = function getVouchesFilterOptions(globaFilterType) {
    switch (globaFilterType) {
      case _constants2.default.globalVouchesFilterTypes.ALL_VOUCHES:
        return _resetFilterOptions(_vouchesFilterOptions);
      default:
        return _vouchesFilterOptions;
    }
  };

  var getbotManagerFilterOptions = function getbotManagerFilterOptions(globaFilterType) {
    switch (globaFilterType) {
      case _constants2.default.globalBotManagerFilterTypes.ALL_BOT_FLOWS:
        return _resetFilterOptions(_botManagerFilterOptions);
      default:
        return _botManagerFilterOptions;
    }
  };

  var getbotSessionsFilterOptions = function getbotSessionsFilterOptions(globaFilterType) {
    switch (globaFilterType) {
      case _constants2.default.globalBotSessionsFilterTypes.ALL_BOT_SESSIONS:
        return _resetFilterOptions(_botSessionsFilterOptions);
      default:
        return _botSessionsFilterOptions;
    }
  };

  // Global filter modifiers

  var _applyPAYGModifier = function _applyPAYGModifier(filterOptions) {
    var modifiedFilter = filterOptions.map(function (option) {
      var optionModified = void 0;
      if (option.field == "membershipTypeName") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: "PayAsYouGo" });
      } else {
        optionModified = (0, _assign2.default)({}, option, { isActive: false });
      }

      return optionModified;
    });
    console.log("Modified Filter", modifiedFilter);
    return modifiedFilter;
  };

  var _applyPayingSinceModifier = function _applyPayingSinceModifier(filterOptions) {
    var modifiedFilter = filterOptions.map(function (option) {
      var optionModified = void 0;
      if (option.field == "paymentInfo.payingMemberSince") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 1 });
      } else {
        optionModified = (0, _assign2.default)({}, option, { isActive: false });
      }

      return optionModified;
    });
    console.log("Modified Filter", modifiedFilter);
    return modifiedFilter;
  };

  var _applyNSWModifier = function _applyNSWModifier(filterOptions) {
    var modifiedFilter = filterOptions.map(function (option) {
      var optionModified = void 0;
      if (option.field == "addresses.state") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 'nsw' });
      } else {
        optionModified = (0, _assign2.default)({}, option, { isActive: false });
      }

      return optionModified;
    });
    console.log("Modified Filter", modifiedFilter);
    return modifiedFilter;
  };

  var _applyVICModifier = function _applyVICModifier(filterOptions) {
    var modifiedFilter = filterOptions.map(function (option) {
      var optionModified = void 0;
      if (option.field == "addresses.state") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 'vic' });
      } else {
        optionModified = (0, _assign2.default)({}, option, { isActive: false });
      }

      return optionModified;
    });
    console.log("Modified Filter", modifiedFilter);
    return modifiedFilter;
  };

  var _applyPendingVerificationCertificatesModifier = function _applyPendingVerificationCertificatesModifier(filterOptions) {
    var modifiedFilter = filterOptions.map(function (option) {
      var optionModified = void 0;
      if (option.field == "accountStatus") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 1 });
      } else if (option.field == "certificateStatus") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 1 });
      } else {
        optionModified = (0, _assign2.default)({}, option, { isActive: false });
      }

      return optionModified;
    });
    console.log("Modified Filter", modifiedFilter);
    return modifiedFilter;
  };

  var _applyJobsPostedTodayModifier = function _applyJobsPostedTodayModifier(filterOptions) {
    var modifiedFilter = filterOptions.map(function (option) {
      var optionModified = void 0;
      if (option.field == "postDate") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: _common2.default.converToUtcDate(new Date()), filterItemSelected: 1 });
      } else {
        optionModified = (0, _assign2.default)({}, option, { isActive: false });
      }

      return optionModified;
    });
    console.log("Modified Filter", modifiedFilter);
    return modifiedFilter;
  };

  var _applyJobsExpireTodayModifier = function _applyJobsExpireTodayModifier(filterOptions) {
    var modifiedFilter = filterOptions.map(function (option) {
      var optionModified = void 0;
      if (option.field == "expiresInDays") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 1, filterItemSelected: 1 });
      } else {
        optionModified = (0, _assign2.default)({}, option, { isActive: false });
      }

      return optionModified;
    });
    console.log("Modified Filter", modifiedFilter);
    return modifiedFilter;
  };

  var _applyRecurringJobsPosted15DaysAgoModifier = function _applyRecurringJobsPosted15DaysAgoModifier(filterOptions) {
    var modifiedFilter = filterOptions.map(function (option) {
      var optionModified = void 0;
      if (option.field == "postDate") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: _common2.default.subtractDays(new Date(), 15), filterItemSelected: 1 });
      } else if (option.field == "jobType") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 14, filterItemSelected: 2 });
      } else {
        optionModified = (0, _assign2.default)({}, option, { isActive: false });
      }

      return optionModified;
    });
    console.log("Modified Filter", modifiedFilter);
    return modifiedFilter;
  };

  var _applyNSWBusinessModifier = function _applyNSWBusinessModifier(filterOptions) {
    var modifiedFilter = filterOptions.map(function (option) {
      var optionModified = void 0;
      if (option.field == "state") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 'nsw' });
      } else if (option.field == "locationType") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: _constants2.default.locationType.CENTRE_BASED_DAYCARE });
      } else if (option.field == "helpersCount") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 100, filterItemSelected: 3 });
      } else {
        optionModified = (0, _assign2.default)({}, option, { isActive: false });
      }

      return optionModified;
    });
    console.log("Modified Filter", modifiedFilter);
    return modifiedFilter;
  };

  var _applyVICBusinessModifier = function _applyVICBusinessModifier(filterOptions) {
    var modifiedFilter = filterOptions.map(function (option) {
      var optionModified = void 0;
      if (option.field == "state") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 'vic' });
      } else if (option.field == "locationType") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: _constants2.default.locationType.CENTRE_BASED_DAYCARE });
      } else if (option.field == "helpersCount") {
        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 100, filterItemSelected: 3 });
      } else {
        optionModified = (0, _assign2.default)({}, option, { isActive: false });
      }

      return optionModified;
    });
    console.log("Modified Filter", modifiedFilter);
    return modifiedFilter;
  };

  var _resetFilterOptions = function _resetFilterOptions(filterOptions) {
    var modifiedFilter = filterOptions.map(function (option) {
      var optionModified = (0, _assign2.default)({}, option, { isActive: false });
      return optionModified;
    });
    console.log("Modified Filter", modifiedFilter);
    return modifiedFilter;
  };

  return {
    generateFilterExpression: generateFilterExpression,
    getAppliedFilters: getAppliedFilters,
    getUsersFilterOptions: getUsersFilterOptions,
    getProfilesFilterOptions: getProfilesFilterOptions,
    getMediaFilterOptions: getMediaFilterOptions,
    getSurveyFilterOptions: getSurveyFilterOptions,
    getCertificatesFilterOptions: getCertificatesFilterOptions,
    getChecksFilterOptions: getChecksFilterOptions,
    getJobsFilterOptions: getJobsFilterOptions,
    getAffiliatesFilterOptions: getAffiliatesFilterOptions,
    getVouchesFilterOptions: getVouchesFilterOptions,
    getbotManagerFilterOptions: getbotManagerFilterOptions,
    getbotSessionsFilterOptions: getbotSessionsFilterOptions,
    getGlobalUsersFilterOptions: getGlobalUsersFilterOptions,
    getGlobalJobsFilterOptions: getGlobalJobsFilterOptions,
    getGlobalAffiliatesFilterOptions: getGlobalAffiliatesFilterOptions,
    getGlobalVocuhesFilterOptions: getGlobalVocuhesFilterOptions,
    getGlobalCertificatesFilterOptions: getGlobalCertificatesFilterOptions,
    getGlobalCheckssFilterOptions: getGlobalCheckssFilterOptions,
    getGlobalBotManagerFilterOptions: getGlobalBotManagerFilterOptions,
    getGlobalBotSessionsFilterOptions: getGlobalBotSessionsFilterOptions,
    getGlobalBusinessesFilterOptions: getGlobalBusinessesFilterOptions,
    getBusinessesFilterOptions: getBusinessesFilterOptions,
    getJobRequestsFilterOptions: getJobRequestsFilterOptions,
    getGlobalJobRequestsFilterOptions: getGlobalJobRequestsFilterOptions
  };
};

exports.default = FilterService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/filter.service.js
 **/